import { render, staticRenderFns } from "./HuntingWordsForm.vue?vue&type=template&id=5edef49d&scoped=true&"
import script from "./HuntingWordsForm.vue?vue&type=script&lang=js&"
export * from "./HuntingWordsForm.vue?vue&type=script&lang=js&"
import style0 from "./HuntingWordsForm.vue?vue&type=style&index=0&id=5edef49d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edef49d",
  null
  
)

export default component.exports